import React, { useState } from 'react';
import { List, ListItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { maxMobileSize } from '../../../utils/constants';
import classes from './scss/appliedJobsList.module.scss';
import TableSkeleton from '../Skeletons/TableSkeleton';
import AppliedJobCard from '../Cards/AppliedJobCard/AppliedJobCard';
import MobileThreeDot from '../ModalWindows/MobileThreeDot';
import { useWindowSize } from '../../../utils/hooks';
// eslint-disable-next-line import/no-named-as-default-member
import AppliedJobTableItem from '../Cards/AppliedJobTableItem/AppliedJobTableItem';
import { isJobActive } from '../../../utils/helpers';
import JobCardSkeleton from '../Skeletons/JobCardSkeleton';
import Table from '../Table/Table';
import { appliedJobsConstant } from '../../pages/jobs/constants/appliedJobs';

function AppliedJobsList(props) {
  const { jobsData, pendingFetch } = props;

  const [showThreeDotMenu, setShowThreeDotMenu] = useState(null);
  const { t } = useTranslation();
  const size = useWindowSize();

  return size.width > maxMobileSize ? (
    <Table cols={appliedJobsConstant(t)} pendingFetch={pendingFetch} data={jobsData} />
  ) : (
    <div data-testid="mobile" className="d-flex flex-column gap-3 mb-3">
      {/* eslint-disable-next-line no-nested-ternary */}
      {pendingFetch ? (
        Array.from({ length: 5 }, (v, k) => k)
          // eslint-disable-next-line react/no-array-index-key
          .map((_, idx) => <JobCardSkeleton key={idx} qty={6} />)
      ) : jobsData?.length === 0 || !Array.isArray(jobsData) ? (
        <h6>{t('dashboard.jobs.appliedlist.nojobs')}</h6>
      ) : (
        jobsData.map((item) => (
          <AppliedJobCard
            key={item.JobId}
            job={item.Job}
            jobId={item.JobId}
            cretedDate={item.CreatedDate}
            status={item?.JobApplicationStatus?.UIName}
            menuHandler={() => setShowThreeDotMenu(item.JobId)}
            dots={false}
          />
        ))
      )}
      <MobileThreeDot title="Options" open={!!showThreeDotMenu} closeHandler={() => setShowThreeDotMenu(null)}>
        <List>
          {isJobActive(jobsData?.find((item) => item.JobId === showThreeDotMenu)) && (
            <Link style={{ color: 'black', textDecoration: 'none' }} to={`/dashboard/jobs/${showThreeDotMenu}`}>
              <ListItem>{t('dashboard.jobs.view')}</ListItem>
            </Link>
          )}
        </List>
      </MobileThreeDot>
    </div>
  );
}

export default AppliedJobsList;
